<template>
  <div id="help-login-detail" class="help">
    <call />
    <!-- header -->
    <top-bar title="ヘルプ" backUrl="/help/login"/>
    <!-- main -->
    <main>
      <footer-app page="top" :loading="loading"></footer-app>
      <section>
        <div class="l-main--bg-border l-main--bg-border--pink">
          <div class="l-main__body">
            <div class="l-check-cart">
              <div class="l-check-cart__head pb-50">
                <div class="l-check-cart__title text-left">アカウント連携</div>
                <div class="help-card mb-16">
                  <div class="l-check-cart__title text-left">Googleアカウントでログイン<br />（一度もGoogleにログインしていない場合）</div>
                  <div class="detail-wrap">
                    <p class="l-check-cart__title text-left">1.「Googleアカウントでログイン」ボタンをタップ</p>
                    <p>「Googleでログイン」ボタンをタップします。</p>
                    <img class="border" src="/assets/images/help/help-login-google-1.png" alt="" />
                  </div>
                  <div class="detail-wrap">
                    <p class="l-check-cart__title text-left">2. メールアドレスを入力</p>
                    <p>①利用するGoogleアカウントのメールアドレスまたは電話番号を入力してください。<br />②次へボタンを押してください。</p>
                    <img src="/assets/images/help/help-login-google-2.png" alt="" />
                  </div>
                  <div class="detail-wrap">
                    <p class="l-check-cart__title text-left">3. パスワードを入力</p>
                    <p>①利用するGoogleアカウントのパスワードを入力してください。<br />②次へボタンを押すとログインします。</p>
                    <img class="help-m-b-0" src="/assets/images/help/help-login-google-3.png" alt="" />
                  </div>
                </div>
                <div class="help-card mb-51">
                  <div class="l-check-cart__title text-left">Googleアカウントでログイン<br />（Googleログインしたことがある場合）</div>
                  <div class="detail-wrap">
                    <p class="l-check-cart__title text-left">1.Googleでログインボタンをタップ</p>
                    <p>「Googleでログイン」ボタンをタップしてください。</p>
                    <img class="border" src="/assets/images/help/help-login-google-4.png" alt="" />
                  </div>
                  <div class="detail-wrap">
                    <p class="l-check-cart__title text-left">2. メールアドレスを入力</p>
                    <p>アカウントの一覧が表示されます。使用するアカウントを選択するとログインします。</p>
                    <img src="/assets/images/help/help-login-google-5.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <button-back />
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import TopBar from "../components/TopBar.vue";
import Footer from "../components/Footer.vue";
import ButtonBack from "../components/ButtonBack.vue";

export default Vue.extend({
  name: "HelpLoginDetail",
  components: {
    TopBar,
    FooterApp: Footer,
    ButtonBack,
  },
  mixins: [Tenant],
  data() {
    return {
      loading: false,
    };
  },
  created() {
    this.init();
  },
  mounted() {
    Common.initDom();
  },
  methods: {
    async init() {
      Common.vueInitFunc(this);
      this.loading = false;
    },
  },
});
</script>